<!-- Backdrop overlay -->
<div
  class="backdrop-overlay"
  [class.active]="isDrawerOpen"
  (click)="handleBackdropClick($event)"
></div>

<!-- Info Drawer -->
<div
  class="info-drawer"
  [class.opened]="isDrawerOpen"
  [ngStyle]="{ 'z-index': isDrawerOpen ? 999 : 1 }"
>
  <button
    type="button"
    class="drawer-toggle text-white"
    (click)="toggleDrawer()"
    title="VAM Activity"
  >
    <img
      [src]="domain + '/assets/svgs/vector.svg'"
      class="info-icon"
      [class.active]="isDrawerOpen"
    />
  </button>

  <div class="drawer-content">
    <!-- Language Toggle -->
    <!-- <div class="language-toggle">
        <div class="toggle-group">
          <div class="toggle-item">
            <input type="radio" [checked]="currentLang === 'en'" name="lang" value="en" id="eng" (change)="setLocale('en')" />
            <label for="eng">In English</label>
          </div>

          <div class="toggle-item">
            <input type="radio" [checked]="currentLang === 'ar'" name="lang" value="ar" id="ar" (change)="setLocale('ar')" />
            <label for="ar">In Arabic</label>
          </div>
        </div>
      </div> -->

    <!-- Top Navigation -->
    <nav class="top-nav">
      <div style="width: 250px; margin: 0 auto"></div>

      <div style="display: flex; align-items: center; justify-content: space-around; flex: 1">
        <div
          class="nav-icon"
          [class.active]="activeTab === 'INFORMATION'"
          (click)="setTab('INFORMATION')"
          title="Information"
        >
          <img [src]="domain + '/assets/svgs/car.svg'" alt="" srcset="" />
        </div>

        <div
          class="nav-icon"
          [class.active]="activeTab === 'OPTIONS'"
          (click)="setTab('OPTIONS')"
          title="Options"
        >
          <img [src]="domain + '/assets/svgs/frame61.svg'" alt="" srcset="" />
        </div>

        <div
          class="nav-icon"
          [class.active]="activeTab === 'FLAGS'"
          (click)="setTab('FLAGS')"
          title="Flags"
        >
          <img [src]="domain + '/assets/svgs/frame74.svg'" alt="" srcset="" />
        </div>

        <!-- <div
        class="nav-icon"
        [class.active]="activeTab === 'RATING'"
        (click)="setTab('RATING')"
        title="Rating"
      >
        <img [src]="domain + '/assets/svgs/frame72.svg'" alt="" srcset="" />
      </div> -->

        <div
          class="nav-icon"
          [class.active]="activeTab === 'GALLERY'"
          (click)="setTab('GALLERY')"
          title="Gallery"
        >
          <img [src]="domain + '/assets/svgs/frame73.svg'" alt="" srcset="" />
        </div>
      </div>
    </nav>

    <app-activity-skeleton *ngIf="isLoading"></app-activity-skeleton>

    <div class="main-content" *ngIf="!isLoading && !apiError && logExists">
      <!-- Session Navigation Sidebar -->
      <div class="session-nav">
        <div class="session-list">
          <div
            *ngFor="let session of sessions | keyvalue; let i = index"
            class="session-item"
            [class.active]="session.key === activeSessionKey"
            (click)="setActiveSession(session.key, session.value)"
          >
            <div class="session-info">
              <span class="session-date">{{ formatDate(session.key) }}</span>
              <!-- <span class="mx-2">|</span>
              <span class="session-label">session {{ session?.['id'] }}</span> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="content">
        <div class="header">
          <div class="header-name">
            <img [src]="domain + '/assets/svgs/user.svg'" alt="" srcset="" />
            <span>User</span>
          </div>
          <div class="header-name">
            <img [src]="domain + '/assets/svgs/calendar.svg'" alt="" srcset="" />
            <span>Date</span>
          </div>
          <div class="header-name">
            <img [src]="domain + '/assets/svgs/update.svg'" alt="" srcset="" />
            <span>Updates</span>
          </div>
        </div>

        <div class="sessions">
          <div class="session" *ngFor="let sessionGroup of activeSession">
            <ng-container *ngFor="let session of sessionGroup | keyvalue">
              <div>
                <div class="session-row">
                  <div [title]="session.value.user">
                    {{ truncateString(session.value.user, 20) }}
                  </div>
                  <div>{{ session.value.date }}</div>
                  <div>
                    <button class="update-button" (click)="toggleSession(session.value.session_id)">
                      See all updates
                      <ng-container *ngIf="expandedSession === session.key">
                        <ion-icon name="chevron-down-outline" class="arrow"></ion-icon>
                      </ng-container>

                      <ng-container *ngIf="expandedSession !== session.key">
                        <ion-icon name="chevron-up-outline" class="arrow"></ion-icon>
                      </ng-container>
                    </button>
                  </div>
                </div>
                <div
                  class="updates"
                  *ngIf="expandedSession === session.value.session_id"
                  style="width: 100%"
                >
                  <div class="updates-header">
                    <div>Field</div>
                    <div>Previous</div>
                    <div>Updated</div>
                  </div>
                  <div
                    class="update-row-wrapper"
                    [ngStyle]="{
                      overflow: activeTab === 'GALLERY' ? null : 'auto'
                    }"
                  >
                    <ng-container *ngFor="let update of session.value.updates">
                      <div class="update-row">
                        <div>{{ formatString(update.field) }}</div>
                        <ng-container *ngIf="activeTab !== 'GALLERY'">
                          <div>{{ update.previous_value }}</div>
                          <div class="updated-value">{{ update.updated_value }}</div>
                        </ng-container>

                        <ng-container *ngIf="activeTab === 'GALLERY'">
                          <div class="image-container">
                            <!-- Previous value image handling -->
                            <div
                              class="image-wrapper"
                              (mouseenter)="showPreviewModal('previous')"
                              (mouseleave)="hidePreviewModal('previous')"
                            >
                              View
                              <div *ngIf="showPreviousPreview" class="image-preview-modal">
                                <img
                                  [src]="imageBasePath + update.previous_value"
                                  [alt]="
                                    update?.previous_value === 'No Image'
                                      ? 'Image not available'
                                      : 'Previous image'
                                  "
                                />
                              </div>
                            </div>
                            <div>|</div>
                            <div
                              class="image-actions"
                              [title]="
                                update?.updated_value === 'No Image' ? 'Image not available' : ''
                              "
                            >
                              <button
                                [disabled]="update?.previous_value === 'No Image'"
                                (click)="openImageInNewTab(imageBasePath + update.previous_value)"
                              >
                                Open <ion-icon name="open-outline"></ion-icon>
                              </button>
                            </div>
                          </div>

                          <div class="image-container updated-value">
                            <!-- Updated value image handling -->
                            <div
                              class="image-wrapper"
                              (mouseenter)="showPreviewModal('updated')"
                              (mouseleave)="hidePreviewModal('updated')"
                            >
                              View
                              <div *ngIf="showUpdatedPreview" class="image-preview-modal">
                                <img
                                  [src]="imageBasePath + update.updated_value"
                                  [alt]="
                                    update?.previous_value === 'No Image'
                                      ? 'Image not available'
                                      : 'Updated image'
                                  "
                                />
                              </div>
                            </div>
                            <div>|</div>
                            <div
                              class="image-actions"
                              [title]="
                                update?.updated_value === 'No Image' ? 'Image not available' : ''
                              "
                            >
                              <button
                                [disabled]="update?.updated_value === 'No Image'"
                                (click)="openImageInNewTab(imageBasePath + update.updated_value)"
                              >
                                Open <ion-icon name="open-outline"></ion-icon>
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!logExists && !apiError" class="error-container">
      <h1>No record found for this vehicle: {{ vehicleId }}</h1>
    </div>

    <div class="error-container" *ngIf="apiError">
      <h1>Unable to load {{ activeTab.toLowerCase() }} data</h1>
      <p>Please try again.</p>
      <button (click)="fetchLogs()">Retry</button>
    </div>
  </div>
</div>
